<template>
  <v-card-text class="pb-0 pt-4">
    <v-row class="py-0 pl-3">
      <div class="py-0 comment-card">
        <v-list-item>
          <v-list-item-avatar>
            <img :src="comment.publisher.image" />
          </v-list-item-avatar>

          <v-list-item-content
            v-if="!openEditComment && comment.text.length > 0"
          >
            <v-row class="ma-0 pa-0">
              <div class="body-2 comment-style">
                <v-list-item-title class="pb-2"
                  >{{ comment.publisher.firstName }}
                  {{ comment.publisher.lastName }}</v-list-item-title
                >

                <v-list-item-subtitle style="white-space: normal !important"
                  ><span
                    v-html="comment.text.replace(/(?:\r\n|\r|\n)/g, '<br />')"
                    class="comment-text"
                  ></span
                ></v-list-item-subtitle>
              </div>
              <v-menu offset-y v-if="canDelete || canEdit">
                <template v-slot:activator="{ attrs, on }">
                  <v-btn icon class="my-a ml-1">
                    <v-icon color="grey" v-bind="attrs" v-on="on"
                      >mdi-dots-horizontal</v-icon
                    >
                  </v-btn>
                </template>
                <v-list dense class="list-menu">
                  <v-list-item
                    v-if="canEdit"
                    class="sub-menu"
                    @click="editComment(comment._id)"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon class="fa-fw">far fa-edit</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider v-if="canEdit && canDelete"></v-divider>
                  <v-list-item
                    class="sub-menu"
                    @click="openDeleteCommentDialog(comment._id)"
                    v-if="canDelete"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon class="fa-fw">far fa-trash-alt</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
            <div class="body-2 mt-2" v-if="comment.image && comment.image.url">
              <v-img
                width="150"
                height="150"
                contain
                aspect-ratio="1"
                v-if="comment.image && comment.image.url"
                :src="comment.image.url"
              ></v-img>
            </div>
            <v-list-item-subtitle class="pl-5">
              <v-list-item style="min-height: fit-content">
                <v-list-item-action class="my-0"
                  ><span
                    @click="unlikeComment()"
                    v-if="liked"
                    class="liked-btn text-capitalize blue--text"
                    ><v-icon small left class="text-capitalize blue--text"
                      >mdi-thumb-up</v-icon
                    >Liked</span
                  >
                  <span @click="likeComment()" v-if="!liked" class="liked-btn"
                    ><v-icon small left>mdi-thumb-up-outline</v-icon>Like</span
                  ></v-list-item-action
                >
                <v-list-item-content>{{
                  comment.created_at | moment
                }}</v-list-item-content>
              </v-list-item></v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-content
            v-else-if="!openEditComment && comment.text.length == 0"
          >
            <div class="body-2" style="max-width: max-content !important">
              <v-list-item-title class="pb-2 pl-4 pt-3"
                >{{ comment.publisher.firstName }}
                {{ comment.publisher.lastName }}
                <v-menu offset-y v-if="canDelete || canEdit">
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn icon class="ml-2 mt-0">
                      <v-icon color="grey" v-bind="attrs" v-on="on"
                        >mdi-dots-horizontal</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list dense class="list-menu">
                    <v-list-item
                      v-if="canEdit"
                      class="sub-menu"
                      @click="editComment(comment._id)"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon class="fa-fw">far fa-edit</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="canEdit && canDelete"></v-divider>
                    <v-list-item
                      class="sub-menu"
                      @click="openDeleteCommentDialog(comment._id)"
                      v-if="canDelete"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon class="fa-fw">far fa-trash-alt</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-title>

              <v-img
                width="150"
                height="150"
                contain
                aspect-ratio="1"
                v-if="comment.image && comment.image.url"
                :src="comment.image.url"
              ></v-img>
            </div>

            <v-list-item-subtitle class="pl-5">
              <v-list-item style="min-height: fit-content">
                <v-list-item-action class="my-0"
                  ><span
                    @click="unlikeComment()"
                    v-if="liked"
                    class="liked-btn text-capitalize blue--text"
                    ><v-icon small left class="text-capitalize blue--text"
                      >mdi-thumb-up</v-icon
                    >Liked</span
                  >
                  <span @click="likeComment()" v-if="!liked" class="liked-btn"
                    ><v-icon small left>mdi-thumb-up-outline</v-icon>Like</span
                  ></v-list-item-action
                >
                <v-list-item-content>{{
                  comment.created_at | moment
                }}</v-list-item-content>
              </v-list-item></v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-content v-else-if="openEditComment"
            ><v-textarea
              autofocus
              v-model="editCommentInput"
              filled
              rounded
              dense
              hide-details
              class="mx-2 mt-2"
              rows="1"
              auto-grow
              @keydown.enter.exact.prevent="updateComment()"
              @keydown.enter.shift.exact.prevent="editCommentInput += '\n'"
              @keydown.esc="cancelEdit()"
            ></v-textarea>
            <v-list-item-subtitle class="pl-5 mb-2">
              <span
                >กด Esc เพื่อ
                <span @click="cancelEdit()" class="cancel-comment"
                  >ยกเลิก</span
                ></span
              ></v-list-item-subtitle
            >
            <div class="body-2 mb-2" v-if="comment.image && comment.image.url">
              <v-img
                width="150"
                height="150"
                contain
                aspect-ratio="1"
                v-if="comment.image && comment.image.url"
                :src="comment.image.url"
              ></v-img>
            </div>
          </v-list-item-content>
        </v-list-item>
        <!-- <div class="body-2 comment-style">{{ comment.text }}</div> -->
      </div>
    </v-row>
    <!-- <v-card-text> -->

    <!-- </v-card-text> -->

    <!-- old -->
    <!-- <v-list-item>
      <v-list-item-avatar class="mr-4">
        <v-img :src="comment.publisher.image" alt="John"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <div class="bubble">
          <v-list-item-title
            >{{ comment.publisher.firstName }}
            {{ comment.publisher.lastName }}</v-list-item-title
          >
          <v-list-item-subtitle>
            {{ comment.text }}
            <lightbox
              v-if="comment.image && comment.image.url"
              class="mt-4"
              :items="[comment.image.url]"
              :cell="1"
              style="height: 100px; width: 100%"
            ></lightbox>
          </v-list-item-subtitle>
        </div>
        <div class="summary">
          <div class="v-list-item__subtitle">
            {{ comment.created_at | moment }}
          </div>
          <v-btn
            x-small
            elevation="0"
            text
            :color="'pink'"
            v-if="liked"
            @click="unLikeComment()"
          >
            <v-icon x-small class="mr-1">{{ "fas fa-heart" }}</v-icon>
            {{ comment.totalLiked || "" }}
          </v-btn>
          <v-btn
            x-small
            elevation="0"
            text
            v-if="!liked"
            @click="likeComment()"
          >
            <v-icon x-small class="mr-1">{{ "far fa-heart" }}</v-icon>
            {{ comment.totalLiked || "" }}
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item> -->
    <v-dialog v-model="showConfirmDeleteDialog" max-width="350px">
      <v-card>
        <v-card-title class="headline font-weight-bold">
          Delete Comment
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 darken-1 pr-0" icon @click="clearParam">
            <v-icon class="pa-0" size="20px">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this comment ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="clearParam"> Cancel </v-btn>
          <v-btn
            class="white--text"
            :color="$buttonColor"
            flat
            @click="deleteComment"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-text>
</template>
<script>
import moment from "moment";
import Vue from "vue";
import { EventBus } from "@/event-bus";
function formatDate(datatime) {
  let datatimes = new Date(datatime);
  let monthNamesThai = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม ",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  var Str =
    ("00" + datatimes.getDate()).slice(-2) +
    " " +
    monthNamesThai[datatimes.getMonth()] +
    " " +
    datatimes.getFullYear();

  return Str;
}
export default {
  props: [
    "comment",
    "postId",
    "onDeleteCommentSuccess",
    "postOwner",
    "ownerOrAdmin",
  ],
  data: () => ({
    // url: "https://api.nerdof.com/api",
    liked: false,
    showConfirmDeleteDialog: false,
    editCommentId: null,
    text: "",
    openEditComment: false,
    editCommentInput: null,
  }),
  beforeDestroy() {
    EventBus.$off("clearEditState");
  },
  mounted() {
    this.liked = this.comment.liked;
    EventBus.$on("clearEditState", (id) => {
      if (this.comment._id !== id) {
        this.cancelEdit();
      }
    });
    // console.log(this.comment);
  },
  computed: {
    canEdit() {
      if (this.comment.publisher.id == Vue.prototype.$userInfo._id) {
        return true;
      }
      return false;
    },
    canDelete() {
      if (this.comment.publisher.id == Vue.prototype.$userInfo._id) {
        return true;
      } else if (this.postOwner == Vue.prototype.$userInfo._id) {
        return true;
      } else if (Vue.prototype.$userInfo.adminCompany) {
        return true;
      } else if (this.ownerOrAdmin) {
        return true;
      }
      //waiting Owner course or admincourse
      return false;
    },
  },
  filters: {
    moment: function (date) {
      let setDate = date / 1000;
      let today = new Date().getTime() / 1000;
      let minutesToday = today / 60;
      let minutesSet = setDate / 60;
      if (minutesToday - minutesSet < 60) {
        let minutes = (minutesToday - minutesSet).toFixed(0);
        return minutes + " นาที";
      } else if ((minutesToday - minutesSet) / 60 < 24) {
        let hour = ((minutesToday - minutesSet) / 60).toFixed(0);
        return hour + " ชม.";
      } else {
        let dateDay = formatDate(date);
        let timeDay = moment(date).format("HH:mm");
        return "เมื่อ " + dateDay + " เวลา " + timeDay + " น.";
      }
    },
  },
  methods: {
    likeComment() {
      Vue.axios
        .post(
          `${this.$store.state.api}/postcomment/like`,
          {
            idpost: this.postId,
            idcomment: this.comment._id,
          },
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.updateItem(res);
          this.comment.totalLiked++;
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    unlikeComment() {
      Vue.axios
        .post(
          `${this.$store.state.api}/postcomment/unlike`,
          {
            idpost: this.postId,
            idcomment: this.comment._id,
          },
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.updateItem(res);
          if (this.comment.totalLiked - 1 >= 0) {
            this.comment.totalLiked--;
          }
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    updateItem(res) {
      if (res.data.status) {
        this.comment.liked === res.data.result.liked;
        this.comment.likes === res.data.result.likes;
        this.liked = res.data.result.liked;
      }
    },
    editComment(data) {
      this.editCommentInput = this.comment.text;
      this.editCommentId = data;
      this.openEditComment = true;
      EventBus.$emit("clearEditState", data);
    },
    updateComment() {
      this.openEditComment = false;
      // if (this.text.trim() == "") {
      //   return;
      // }
      let editCommentData = {
        idpost: this.postId,
        idcomment: this.editCommentId,
        text: this.editCommentInput,
      };
      Vue.axios
        .put(
          `${this.$store.state.api}/postcomment/manage/update`,
          editCommentData,
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          console.log(res);
          this.comment.text = res.data.result.text;
          this.openEditComment = false;
        })
        .catch((err) => {
          this.openEditComment = false;
        });
    },
    cancelEdit() {
      // console.log("cancel update comment");
      this.openEditComment = false;
    },
    openDeleteCommentDialog(commentId) {
      this.editCommentId = commentId;
      this.showConfirmDeleteDialog = true;
    },
    async deleteComment() {
      let dataCreatePost = {
        idpost: this.postId,
        idcomment: this.editCommentId,
      };
      await Vue.axios
        .delete(`${this.$store.state.api}/postcomment/manage/delete`, {
          headers: this.$store.getters.requestHeaders,
          data: dataCreatePost,
        })
        .then(async (res) => {
          await this.onDeleteCommentSuccess(this.editCommentId);
          await this.clearParam();
        })
        .catch(async (err) => {
          await this.clearParam();
        });
    },
    clearParam() {
      this.editCommentId = null;
      this.text = "";
      this.showConfirmDeleteDialog = false;
    },
    formatDate(datatime) {
      let datatimes = new Date(datatime);
      let monthNamesThai = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม ",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];

      var Str =
        ("00" + datatimes.getDate()).slice(-2) +
        " " +
        monthNamesThai[datatimes.getMonth()] +
        " " +
        datatimes.getFullYear();

      return Str;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item {
  display: flex;
  justify-content: flex-start !important;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 8px 16px;

  .v-list-item__avatar {
    align-self: flex-start;
  }

  .v-list-item__content {
    padding: 0 !important;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.bubble {
  background: #f1f3f5;
  padding: 10px 12px !important;
  border-radius: 8px;
  max-width: 100%;
  margin-bottom: 4px;
}

.summary {
  display: flex;
  align-items: center;
  padding-left: 12px;

  .v-list-item__subtitle {
    margin-right: 4px;
    font-size: 12px;
    opacity: 0.75;
  }
}
.v-list-item .v-list-item__content[data-v-182facf7] {
  padding: 0 !important;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.v-list-item[data-v-182facf7] {
  display: flex;
  justify-content: flex-start !important;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 8px 0px;
}
.comment-style {
  background-color: #f0f0f0;
  border-radius: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 15px;
  word-wrap: normal;
  line-break: anywhere;
  max-width: max-content !important;
  width: 80%;
}
.comment-text {
  font-size: 0.95rem !important;
}
.list-menu {
  // .v-list-item--dense .v-list-item__title, .v-list-item--dense .v-list-item__subtitle, .v-list--dense .v-list-item .v-list-item__title, .v-list--dense .v-list-item .v-list-item__subtitle {
  //   font-weight: 400 !important;
  // }
  .v-list-item__title {
    font-weight: 400 !important;
    font-size: 14px !important;
  }
  .v-icon.v-icon {
    font-size: 18px !important;
  }
}
.wrap-it {
  word-wrap: break-word;
}
.sub-menu {
  flex-wrap: nowrap !important;
  padding: 0 16px !important;
}
.liked-btn {
  cursor: pointer;
}
.cancel-comment {
  color: rgb(0, 136, 255);
  cursor: pointer;
}
.comment-card {
  width: auto;
  max-width: 80%;
}
.text-block {
  white-space: pre; // or pre-line
}
.my-a {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
</style>

